import * as Yup from 'yup';

const schema = Yup.object().shape({
  nivel_autorizacao: Yup.number().required('Valor requerido'),
  nomeclatura: Yup.string().required('Valor requerido'),
  obrigatoria: Yup.boolean().required('Valor requerido'),
});

export default schema;
